import template from "./email-preview.html";
import {emailPreviewController} from "./email-preview.controller";
import "./email-preview.scss";

export const emailPreviewComponent = {
    template,
    controller: emailPreviewController,
    controllerAs: "emailPreview",
    bindings: {
        title: "<",
        text: "<",
        data: "@",
        template: "@"
    }
};


// WEBPACK FOOTER //
// ./sources/components/common/email-preview/email-preview.component.js